import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'

import classes from './Rating.module.scss'

/** @type {import('./types').default} */
const Rating = ({ rating, size, className }) => {
  return (
    <div className={clsx('Rating', classes.root, className)}>
      {[1, 2, 3, 4, 5].map(i => (
        <Icon
          icon="usd-circle"
          className={clsx(classes.icon, rating >= i ? classes.teal : classes.grey)}
          key={i}
          size={size}
        />
      ))}
    </div>
  )
}

export default Rating
